export const buildChartjsDataProp = (datasets, labels) => {
  return ({
    labels: labels,
    datasets: datasets,
  })
}
